import { render, staticRenderFns } from "./v-header-box.vue?vue&type=template&id=5db40bb4&scoped=true"
import script from "./v-header-box.vue?vue&type=script&lang=js"
export * from "./v-header-box.vue?vue&type=script&lang=js"
import style0 from "./v-header-box.vue?vue&type=style&index=0&id=5db40bb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db40bb4",
  null
  
)

export default component.exports